import { homeKeys } from '@/features/home/queries/query-keys';
import { fetchAcademyById } from '@/features/home/services';
import { CoachDoc, fetchCoachByUid } from '@/features/home/services/get-coach';
import { WithId } from '@/libs/firebase/firestore';
import { useSessionStore } from '@/stores';
import { QueryObserverResult, useQuery } from '@tanstack/react-query';
import { useShallow } from 'zustand/shallow';

type CoachQueryData = WithId<
  Omit<CoachDoc, 'inactiveFilterLevel'> & { inactiveFilterLevel?: number | null }
>;

export function useCoachQuery(uid?: string): QueryObserverResult<CoachQueryData | null> {
  const roles = useSessionStore(useShallow(s => s.roles));
  return useQuery({
    queryKey: homeKeys.coach(uid),
    queryFn: () => fetchCoachByUid(uid as string),
    enabled: Boolean(uid) && roles.includes('coach'),
    select: (data): CoachQueryData | null => {
      if (!data) return null;
      return {
        ...data,
        inactiveFilterLevel:
          data.inactiveFilterLevel !== null && data.inactiveFilterLevel !== undefined
            ? Number(data.inactiveFilterLevel)
            : undefined,
      };
    },
  });
}

export function useAcademyQuery(academyId?: string | null) {
  return useQuery({
    queryKey: homeKeys.academy(academyId),
    queryFn: () => fetchAcademyById(academyId as string),
    enabled: Boolean(academyId),
  });
}
